import * as React from 'react';
import { Table } from 'rsuite';
import { formatDate } from '../utils/dateUtils';

export const DateCell = ({ ...props }) => (
    <Table.Cell {...props}>
        <div>{formatDate(props.rowData[props.dataKey])}</div>
    </Table.Cell>
);
